<template>
  <div class="index">
    <img class="qiu1"
         src="../assets/images/qiu_1.png"
         alt="">
    <img class="qiu2"
         src="../assets/images/qiu_2.png"
         alt="">
    <img class="qiu3"
         src="../assets/images/qiu_3.png"
         alt="">
    <img class="yunceng"
         src="../assets/images/yunceng.png"
         alt="">
    <!-- <div class="anse" ></div> -->
    <img class="huojian"
         src="../assets/images/huojian.png"
         alt="">
    <div class="head">showworld.com</div>
    <div class="body">Coming soon</div>
    <a href="https://beian.miit.gov.cn/"
       target="_blank"
       class="foot">京ICP备19042276号-5</a>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  width: 100%;
  height: 100%;
  position: relative;
}
.head {
  position: absolute;
  right: 100px;
  top: 60px;
  font-size: 18px;
  color: #fff;
}
.body {
  position: absolute;
  left: 180px;
  top: 327px;
  font-size: 72px;
  color: #fff;
  font-weight: 600;
}
.foot {
  position: absolute;
  left: 50%;
  bottom: 40px;
  font-size: 12px;
  color: #fff;
  transform: translate(-50%, -50%);
}

.qiu1 {
  width: 244px;
  height: 244px;
  position: absolute;
  left: 0px;
  top: 180px;
}
.qiu2 {
  width: 738px;
  height: 738px;
  position: absolute;
  top: -30%;
  right: 240px;
}
.qiu3 {
  width: 392px;
  height: 392px;
  position: absolute;
  right: 40px;
  top: 40px;
}

.huojian {
  width: 640px;
  /* height: 1314px; */
  position: absolute;
  top: -100px;
  right: 100px;
}

.yunceng {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.anse {
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(1, 2, 35, 0.5);
  background-blend-mode: overlay;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue